import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=9ade8514&scoped=true"
import script from "./FullScreen.vue?vue&type=script&lang=js"
export * from "./FullScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ade8514",
  null
  
)

export default component.exports